import { googleApiLoad } from '$helpers/GoogleApiLoad';
import { submitLead } from '$helpers/SubmitLead';
import type {
  UseFormattedProps,
  SectionInPageData,
  SubscriptionStatus,
} from 'customer-components/lib/types';

export const useFormattedProps = (
  props: SectionInPageData,
  subscriptionsStatus: SubscriptionStatus,
): UseFormattedProps => {
  const sectionVariation = `${props.type}${props.activeVariation || ''}`;
  switch (sectionVariation) {
    case 'Footer1':
      return {
        ...props.model,
        subscriptionsStatus,
        googleApiLoad,
      };

    case 'ContactForm':
    case 'ContactForm1':
    case 'ContactForm2':
    case 'ContactForm3':
    case 'FormDiscount':
    case 'MktHero3':
    case 'MktHero4':
      return {
        ...props.model,
        submitLead,
        // The property below is used to initialize the captcha
        // isLandingPage: true
      };
    case 'MktAreasWeService':
      return {
        ...props.model,
        submitLead,
      };
    default: {
      if (sectionVariation.startsWith('Hero')) {
        return {
          ...props.model,
          submitLead,
        };
      }
      return props.model;
    }
  }
};
